import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, Input, Button, Select, DatePicker, Radio } from 'antd'
import { newInvitation } from '../../actions/UsersAction'
import { isEmail, sendNotification } from '../../utils'
import moment from 'moment'

const { Option } = Select
const { TextArea } = Input
const { RangePicker } = DatePicker

export class Invitation extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: '',
      message: '',
      options: [],
      group: [],
      userType: 'Infinite',
      showUserDates: false,
      createAndContinue: false,
      initDate: moment().format('YYYY-MM-DD'),
      dueDate: moment().format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
    const { group } = this.props
    this.setState({
      options: group.map((r, k) => <Option key={k} value={r.name} uid={r._id}>{r.name}</Option>)
    })
  }

  componentDidUpdate(prevProps) {
    const { invitationSent, intl } = this.props
    const { createAndContinue } = this.state

    if (prevProps.invitationSent !== invitationSent && invitationSent) {
      sendNotification('success', intl, intl.formatMessage({ id: 'invitation_sended_success' }))
      if (createAndContinue) {
        this.handleClearForm()
      } else {
        this.props.handleHideinvitationUser()
      }
    }
  }

  componentWillUnmount() {
    this.handleClearForm()
  }

  handleClearForm = () => {
    this.setState({
      email: '',
      message: '',
      createAndContinue: false,
      group: []
    })
  }

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleTextAreaOnChange = e => {
    this.setState({
      message: e.target.value
    })
  }

  handleCreate = e => {
    e.preventDefault()
    this.setState({
      createAndContinue: false
    }, () => this.handleSendInvitation())
  }

  handleRadioType = e => {
    if (e.target.value === 'Temporary') {
      this.setState({
        userType: 'Temporary',
        showUserDates: true
      })
    } else {
      this.setState({
        userType: 'Infinite',
        showUserDates: false
      })
    }
  }

  handleCreateNContinue = e => {
    e.preventDefault()
    this.setState({
      createAndContinue: true
    }, () => this.handleSendInvitation())
  }

  handleOnChangeInitDate = (date, dateString) => {
    const { intl } = this.props
    if (moment(dateString[0]).isBefore(moment())) {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_temporary_init_time_error' }))
    }
    this.setState({
      initDate: dateString
    })
  }

  handleOnChangeDueDate = (date, dateString) => {
    // test
    this.setState({
      dueDate: dateString
    })
  }

  handleOnChangeRangePicker = (date, dateString) => {
    const { isUndefined } = this.state
    const { intl } = this.props

    if (!moment(dateString[0]).isSameOrAfter(moment(), 'day')) {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_temporary_init_time_error' }))
    }

    this.setState({
      initDate: dateString[0],
      dueDate: isUndefined
        ? null
        : dateString[1]
    }, () => {
    })
  }

  handleSendInvitation = () => {
    const { email, message, group, userType, initDate, dueDate } = this.state
    const { workclient, intl, showGroup } = this.props

    if (email === '') {
      sendNotification('error', intl, intl.formatMessage({ id: 'empty_email_input' }))
      return
    } else if (!isEmail(email)) {
      sendNotification('error', intl, intl.formatMessage({ id: 'not_valid_email' }))
      return
    } else if (showGroup && group.length === 0) {
      sendNotification('error', intl, intl.formatMessage({ id: 'must_select_group' }))
      return
    } else if (userType === '') {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_not_valid_user_type' }))
      return
    } else if (userType === 'Temporary' && !moment(initDate).isSameOrAfter(moment(), 'day')) {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_temporary_init_time_error' }))
      return
    }
    else {
      this.props.newInvitation(email, 'operator', workclient, group, userType, initDate, dueDate, message)
    }
  }

  handleCancel = () => {
    this.handleClearForm()
    this.props.handleHideinvitationUser()
  }

  handleOnChangeGroup = (item, list) => {
    this.setState({ group: list.map(r => r.props.uid) })
  }

  render() {
    const { email, message, createAndContinue, options, initDate, dueDate, showUserDates } = this.state
    const { isFetching, newColor, intl, width, showGroup = true } = this.props
    const isMobile = width
      ? width <= 578
        ? true
        : false
      : false
    return (
      <Form>
        {/* <Form.Item>
          <span>{intl.formatMessage({ id: 'name' })}</span>
          <Input name="name" value={name} placeholder={intl.formatMessage({ id: 'name' })} onChange={this.handleInputOnChange} />
        </Form.Item> */}
        <Form.Item>
          <span>Email</span>
          <Input name="email" value={email} placeholder={intl.formatMessage({ id: 'email' })} onChange={this.handleInputOnChange} />
        </Form.Item>
        {showGroup && <Form.Item>
          <span>{intl.formatMessage({ id: 'groups' })}</span>
          <Select
            mode="multiple"
            placeholder={intl.formatMessage({ id: 'select' })}
            onChange={this.handleOnChangeGroup}
            style={{ width: '100%' }}>
            {options}
          </Select>
        </Form.Item>}
        <span>{intl.formatMessage({ id: 'invitation_habilited_user' })}</span>
        <br />
        <Radio.Group onChange={this.handleRadioType} defaultValue={"Infinite"} size="small">
          <Radio value={"Infinite"} > {intl.formatMessage({ id: "invitation_type_user_infinite" })}
          </Radio>
          <Radio value={"Temporary"} > {intl.formatMessage({ id: "invitation_type_user_temporary" })}
          </Radio>
        </Radio.Group>
        <br />
        {
          showUserDates && isMobile &&
          <div>
            <span>{intl.formatMessage({ id: "copyright_creation_date" })}</span>
            <div>
              <DatePicker
                placeholder={intl.formatMessage({ id: "copyright_date_picker" })}
                onChange={this.handleOnChangeInitDate}
                defaultValue={moment(initDate, 'YYYY-MM-DD')} />
            </div>
            <span>{intl.formatMessage({ id: "copyright_due_date" })}</span>
            <div>
              <DatePicker
                placeholder={intl.formatMessage({ id: "copyright_date_picker" })}
                onChange={this.handleOnChangeDueDate}
                defaultValue={dueDate ? moment(dueDate, 'YYYY-MM-DD') : null} />
            </div>
          </div>
        }
        {
          showUserDates && !isMobile &&
          <div>
            <RangePicker
              placeholder={intl.formatMessage({ id: "copyright_date_picker" })}
              onChange={this.handleOnChangeRangePicker}
              defaultValue={[moment(initDate, 'YYYY-MM-DD'), dueDate ? moment(dueDate, 'YYYY-MM-DD') : null]}
            />
          </div>
        }
        <Form.Item>
          <span>{intl.formatMessage({ id: 'message' })}</span>
          <TextArea rows={3} value={message} placeholder={intl.formatMessage({ id: 'message' })} onChange={this.handleTextAreaOnChange} />
        </Form.Item>
        <Form.Item>
          <Button
            loading={isFetching && !createAndContinue}
            type="primary"
            style={{ backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleCreate}>{intl.formatMessage({ id: 'send' })}</Button>
          <Button
            loading={isFetching && createAndContinue}
            type="primary"
            style={{ backgroundColor: newColor, borderColor: newColor, marginLeft: '5px' }}
            onClick={this.handleCreateNContinue}>{intl.formatMessage({ id: 'send_continue' })}</Button>
          <Button
            type="default"
            style={{ color: newColor, borderColor: newColor, marginLeft: '5px', width: '87px', justifyContent: 'center' }}
            onClick={this.handleCancel}>{intl.formatMessage({ id: 'cancel_button' })}</Button>
        </Form.Item>
      </Form >
    )
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.users.invitationIsFetching,
    invitationSent: state.users.invitationSent,
    group: state.group.byClientData
  }
}

const mapDispatchToProps = {
  newInvitation
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Invitation)))